/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import createWebStorage from "redux-persist/lib/storage/createWebStorage";
import { Middleware } from "@reduxjs/toolkit";
import rootReducer from "./reducers";
import { api } from "./api";
const loggerMiddleware: Middleware = (storeAPI) => (next) => (action) => {
  console.log("➡️ dispatching:", action);
  const result = next(action);
  console.log("⬅️ next state:", storeAPI.getState());
  return result;
};

const createNoopStorage = () => {
  return {
    getItem(_: string) {
      return Promise.resolve(null);
    },
    setItem(_: string, value: string) {
      return Promise.resolve(value);
    },
    removeItem(_: string) {
      return Promise.resolve();
    },
  };
};

const storage =
  typeof window === "undefined"
    ? createNoopStorage()
    : createWebStorage("local");

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "setting"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const makeStore = () => {
  const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }).concat(api.middleware),
    // .concat(loggerMiddleware),
  });

  return store;
};
export const store = makeStore();
export const persistor = persistStore(store);
export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
